import React from 'react'
import {IdeationResultsComments} from '../IdeationResultsComments/IdeationResultsComments'
import styles from './IdeationResultsDefaultsIdea.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../../../Translation/English/global'
import type {IExploreIdea} from '../../../../../types'

interface IIdeationResultsDefaultsIdeaProps {
  defaultIdea: IExploreIdea
}

export const IdeationResultsDefaultsIdea: React.FC<
  IIdeationResultsDefaultsIdeaProps
> = ({defaultIdea}) => {
  const wt = useWt()

  return (
    <div className={styles.ideationDefaultIdea}>
      <div className={styles.votes}>
        <div className={styles.countsBlock}>
          <span className={styles.counts}>{defaultIdea?.votesCount}</span>
          <span className={styles.title}>
            {defaultIdea?.votesCount > 1
              ? String(wt(GLOBAL.votes))
              : String(wt(GLOBAL.vote))}
          </span>
        </div>
        <div className={styles.column} />

        <div className={styles.titleBlock}>{defaultIdea?.text}</div>
      </div>
      <IdeationResultsComments
        idea={defaultIdea}
        btnClassName={styles.commentsBtn}
        commentsBlockClassName={styles.commentsBlock}
      />
    </div>
  )
}
